import { StoreModule } from '@ngrx/store';
import { NgModule } from '@angular/core';

import { APP_FEATURE, appReducer } from './app.reducer';

/**
 * Services of Application Module.
 */
import { AppService } from './app.service';

/**
 * Feature module of Application Module.
 */
import { SharedModule } from '../shared/shared.module';
import { EffectsModule } from '@ngrx/effects';
import { AppEffects } from './app.effects';

@NgModule({
  imports: [
    StoreModule.forFeature(APP_FEATURE, appReducer),
    EffectsModule.forFeature([AppEffects]),
    SharedModule,
  ],
  providers: [AppService]
})
export class ApplicationModule {
}
